var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("layout-card", {
    staticClass: "card-marketing_campaign",
    attrs: {
      isCustomizable: _vm.settings.isCustomizable,
      placeholder: _vm.placeholder,
      placeholderImg:
        "/ressources/logged/img/dashboard/dashboard-marketing.svg",
      error: _vm.error,
      loading: _vm.loading
    },
    on: {
      "hide-card": function($event) {
        return _vm.$emit("hide-card", "marketing_campaign")
      },
      "refresh-card": function($event) {
        return _vm.fetchCard("marketing_campaign", {}, true)
      }
    },
    scopedSlots: _vm._u([
      {
        key: "title",
        fn: function() {
          return [
            _vm._v("\n        " + _vm._s(_vm.name) + "\n        "),
            _c("span", { staticClass: "fs-3 regular gray-60 ml-2" }, [
              _vm._v(_vm._s(_vm.$l10n.__("10 dernières campagnes envoyées")))
            ])
          ]
        },
        proxy: true
      },
      {
        key: "actions",
        fn: function() {
          return [
            _vm.settings.canCreate
              ? _c("CompassIconButton", {
                  attrs: { icon: "plus", onclick: "Campaign.create()" }
                })
              : _vm._e()
          ]
        },
        proxy: true
      },
      {
        key: "content",
        fn: function() {
          return [
            (_vm.cardData && _vm.cardData.length > 0) ||
            (_vm.cardData && _vm.cardData.error)
              ? _c(
                  "div",
                  { staticClass: "hp-10", attrs: { onresize: "resizeCard()" } },
                  [
                    !_vm.cardData.error
                      ? _c(
                          "div",
                          [
                            _c(
                              "el-table",
                              {
                                ref: "table",
                                staticClass: "table-ellipsis",
                                staticStyle: { width: "100%" },
                                attrs: {
                                  data: _vm.cardData,
                                  headerCellClassName: "grey semibold",
                                  rowClassName: "no-hover",
                                  height: "100%",
                                  stripe: ""
                                }
                              },
                              [
                                _c("el-table-column", {
                                  attrs: { prop: "name", width: "250" },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function(scope) {
                                          return [
                                            _c(
                                              "a",
                                              {
                                                attrs: {
                                                  id: "link",
                                                  href: scope.row.link
                                                }
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "gray-100 semibold"
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(scope.row.name)
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "p",
                                                  { staticClass: "grey mt-1" },
                                                  [
                                                    _vm._v(
                                                      "\n                                    " +
                                                        _vm._s(
                                                          _vm.$filters.dateFormatter(
                                                            scope.row.date,
                                                            "SLASHED_DATE_TIME"
                                                          )
                                                        ) +
                                                        "\n                                "
                                                    )
                                                  ]
                                                )
                                              ]
                                            )
                                          ]
                                        }
                                      }
                                    ],
                                    null,
                                    false,
                                    1414368846
                                  )
                                }),
                                _vm._v(" "),
                                _c("el-table-column", {
                                  attrs: {
                                    prop: "recipients",
                                    label: _vm.$t.__(
                                      "dashboard.cards.MarketingCampaignCard.recipients"
                                    ),
                                    headerAlign: "right",
                                    align: "right"
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function(scope) {
                                          return [
                                            _c("p", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.formatStats(
                                                    scope.row.recipients
                                                  )
                                                )
                                              )
                                            ])
                                          ]
                                        }
                                      }
                                    ],
                                    null,
                                    false,
                                    1704454257
                                  )
                                }),
                                _vm._v(" "),
                                _c("el-table-column", {
                                  attrs: {
                                    prop: "open",
                                    label: _vm.$t.__(
                                      "dashboard.cards.MarketingCampaignCard.opening"
                                    ),
                                    headerAlign: "right",
                                    align: "right"
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function(scope) {
                                          return [
                                            _c("p", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$filters.numberFormat(
                                                    scope.row.open
                                                  )
                                                ) + "%"
                                              )
                                            ])
                                          ]
                                        }
                                      }
                                    ],
                                    null,
                                    false,
                                    3185385048
                                  )
                                }),
                                _vm._v(" "),
                                _c("el-table-column", {
                                  attrs: {
                                    prop: "click",
                                    label: _vm.$t.__(
                                      "dashboard.cards.MarketingCampaignCard.clics"
                                    ),
                                    headerAlign: "right",
                                    align: "right"
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function(scope) {
                                          return [
                                            _c("p", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.formatStats(
                                                    scope.row.click
                                                  )
                                                )
                                              )
                                            ])
                                          ]
                                        }
                                      }
                                    ],
                                    null,
                                    false,
                                    2680533207
                                  )
                                }),
                                _vm._v(" "),
                                _c("el-table-column", {
                                  attrs: {
                                    prop: "unsub",
                                    label: _vm.$t.__(
                                      "dashboard.cards.MarketingCampaignCard.unsubscribed"
                                    ),
                                    headerAlign: "right",
                                    align: "right"
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function(scope) {
                                          return [
                                            _c("p", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$filters.numberFormat(
                                                    scope.row.unsub
                                                  )
                                                ) + "%"
                                              )
                                            ])
                                          ]
                                        }
                                      }
                                    ],
                                    null,
                                    false,
                                    1007532659
                                  )
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      : _vm._e()
                  ]
                )
              : _vm._e()
          ]
        },
        proxy: true
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }